/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  weight?: "thin" | "normal";
}
export const IconSatellite1 = React.forwardRef<SVGSVGElement, Props>(
  (
    { fill = "none", stroke = "currentColor", weight = "normal", ...props },
    ref,
  ) => (
    <svg
      viewBox="0 0 24 24"
      ref={ref}
      css={css`
        * {
          vector-effect: non-scaling-stroke;
        }
        overflow: visible;
        height: 24px;
      `}
      {...props}
    >
      <g
        fill={fill}
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={weight === "normal" ? 1.5 : 1}
      >
        <path d="M4.779 13.917a3.75 3.75 0 0 1 5.3 5.3l-5.3-5.3zM19.7 8.542a3.001 3.001 0 0 0-.385-4.57 3.113 3.113 0 0 0-3.971.441l-5.792 5.792a1.5 1.5 0 0 0 0 2.121l2.122 2.122a1.5 1.5 0 0 0 2.121 0L19.7 8.542zM21.292 2.708l-1.591 1.591M5.56 19.5a1.5 1.5 0 0 1-1.06-1.073M8.326 22.737a5.3 5.3 0 0 1-7.055-7.078M14.856 13.387l2.121 2.121M16.447 16.039l1.061-1.061a1.5 1.5 0 0 1 2.121 0l3.182 3.182a1.5 1.5 0 0 1 0 2.121l-1.061 1.061a1.5 1.5 0 0 1-2.121 0l-3.182-3.182a1.5 1.5 0 0 1 0-2.121zM10.613 9.144L8.492 7.023M2.658 2.25l1.061-1.061a1.5 1.5 0 0 1 2.121 0l3.182 3.182a1.5 1.5 0 0 1 0 2.121l-1.06 1.061a1.5 1.5 0 0 1-2.121 0L2.658 4.371a1.501 1.501 0 0 1 0-2.121z" />
      </g>
    </svg>
  ),
);
